import {API_BASE} from '../apiConfig';

/**
 * Уход на страницу авторизации Яндекса. Флаг __skipBeforeUnload обязателен:
 * без него глобальный обработчик beforeunload (см. App) показал бы нативное
 * окно «покинуть страницу?» прямо на клике по кнопке входа.
 */
export const goToYandexAuth = () => {
  window.__skipBeforeUnload = true;
  window.location.href = `${API_BASE}/auth/yandex`;
};
